import { FC } from 'react';
import MuiAccordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ArrowUp from 'components/icons/ArrowUp';
import ArrowRight from 'components/icons/ArrowRight';

import { CareerType, CountryCodeType } from 'types/types';
import {
  what_you_need,
  the_role,
  job_position_instruction,
} from 'data/translationKeys';
import useLocalised from 'customHooks/useLocalised/useLocalised';
import { colorConstants, emailAdresses } from 'data/constants';
import CareerForm from './CareerForm';

interface ICareerAccordion {
  expanded: boolean,
  handleChange: (id: number) => void,
  career: CareerType,
  countryCodes: CountryCodeType[],
}

const CareerAccordion: FC<ICareerAccordion> = ({
  expanded,
  handleChange,
  countryCodes,
  career: {
    id,
    name,
    description,
    requirements,
    hasForm
  },
}) => {
  const the_role_text = useLocalised(the_role);
  const what_you_need_text = useLocalised(what_you_need);
  const job_position_instruction_text = useLocalised(job_position_instruction);

  return (
    <MuiAccordion
      expanded={expanded}
      disableGutters
      elevation={0}
      onChange={() => handleChange(id)}
      sx={{
        border: "none",
        ":before": {
          backgroundColor: colorConstants.brandColor,
        },
      }}
    >
      <AccordionSummary
        aria-controls={`${id}`}
        id={`${id}`}
        expandIcon={expanded ? <ArrowUp /> : <ArrowRight />}
      >
        <div className='career-title'>{name}</div>
      </AccordionSummary>
      <AccordionDetails>
        <div className="accordion-container">
          <div className='accordion-container__left'>
            {description && (
              <>
                <div className='career-description-title'>{the_role_text}</div>
                <div className='career-description'>{description}</div>
              </>
            )}
            {requirements && requirements.length > 0 && (
              <>
                <div className='career-description-title'>{what_you_need_text}</div>
                <ul className="career-requirement-list">
                  <div className="career-requirement-list__element"> 
                    <div dangerouslySetInnerHTML={{__html: requirements}} />
                  </div>
                </ul>
              </>
            )}
            {!hasForm && (
              <div className="career-instruction-text">
                {job_position_instruction_text + ' '}
                <a className="career-instruction-text__link" href={`mailto:${emailAdresses.JOB_APPLICATION_RECIPIENT}`}>
                  {emailAdresses.JOB_APPLICATION_RECIPIENT}
                </a>
              </div>
            )}
          </div>
          {hasForm &&(
            <div className='accordion-container__right'>
              <CareerForm countryCodes={countryCodes} />
            </div>
          )}
        </div>
      </AccordionDetails>
    </MuiAccordion>
  );
};

export default CareerAccordion;
